import isNil from 'lodash/isNil.js'

import FormattedRateCost from '../../../../../common/components/FormattedRateCost.js'
import ButtonLink from '../../../../../common/components/Button/ButtonLink.js'

import {
  shippedShippingMethodNameSelector,
  shippedShipperTypeSelector,
  shippedCostSelector,
  shippedShipperCurrencySymbolSelector,
} from '../../../../../data/orders.js'

import {setSelectedOrderNumbers} from '../../../orderListActions.js'
import {
  SHIPPING_TAB,
  setOrderActionPanelCurrentTab,
} from '../../../ActionPanel/orderActionPanelFunctions.js'
import {useSelector} from '../../../../../store.js'

export default function CompactShippedRateDetails({orderNumber}) {
  const shipperType = useSelector((state) =>
    shippedShipperTypeSelector(state, {orderNumber}),
  )
  const shippingMethod = useSelector((state) =>
    shippedShippingMethodNameSelector(state, {orderNumber}),
  )
  const cost = useSelector((state) => shippedCostSelector(state, {orderNumber}))
  const shipperCurrencySymbol = useSelector((state) =>
    shippedShipperCurrencySymbolSelector(state, {
      orderNumber,
    }),
  )

  const showLabelTab = () => {
    setOrderActionPanelCurrentTab(SHIPPING_TAB)
    setSelectedOrderNumbers([orderNumber])
  }

  if (!shippingMethod) {
    return (
      <div>
        <ButtonLink className="v-align-base fs-n1" onClick={showLabelTab}>
          Create a label
        </ButtonLink>
      </div>
    )
  }

  return (
    <div>
      <ButtonLink className="darker v-align-base" onClick={showLabelTab}>
        <span
          className={`inline-block v-align-top selected-shipper selected-shipper--${shipperType}`}
        />
        <span className="fs-n1">{shippingMethod}</span>
        {!isNil(cost) && (
          <span>
            <span className="fs-n1"> - </span>
            <span className="fs-n1">
              <FormattedRateCost
                cost={cost}
                currencySymbol={shipperCurrencySymbol}
              />
            </span>
          </span>
        )}
      </ButtonLink>
    </div>
  )
}
